<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Partner" bc1="App" bc2="Partner" bc3="Details"></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn btn-gradient-danger btn-sm" @click="backTo">
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <section class="app-user-list">
          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">
                    Accounts Details
                    <small class="text-muted ml-50" v-if="partner">
                      {{ partner.first_name }} {{ partner.last_name }} ({{ partner.email }})
                    </small>
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="card">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>Account Number</th>
                                <th>Account Title</th>
                                <th>Balance</th>
                                <th>Balance On Hold</th>
                                <th>Available Balance</th>
                                <th>Status</th>
                                <th>Creation Time/Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="isEmpty(accounts)">
                                <td colspan="7" class="font-weight-bolder font-medium-2 text-center">
                                  No accounts available
                                </td>
                              </tr>
                              <tr v-for="(account, accountIndex) in accounts" :key="accountIndex">
                                <td>{{ account.account_number }}</td>
                                <td>
                                  <span class="badge badge-info">{{ account.account_title }}</span>
                                  <br>
                                  <span v-show="account.is_default == 2" class="badge badge-light-warning mt-1">Rolling Reserve A/C</span>
                                </td>
                                <td>
                                  <span class="font-weight-bolder text-dark">{{ modifyAmount(parseFloat(account.balance / 100).toFixed(8), 8) }}</span>
                                  <br><span class="badge badge-light-success">{{ currencyCode(account) }}</span>
                                  <br><span class="badge badge-light-primary mt-sm-1" style="cursor: pointer" @click="showLedger(account)">show ledger</span>
                                </td>
                                <td>
                                  <span class="font-weight-bolder text-dark">{{ modifyAmount(parseFloat(account.balance_on_hold / 100).toFixed(8), 8) }}</span>
                                  <br><span class="badge badge-light-success">{{ currencyCode(account) }}</span>
                                  <!-- TODO: enable once the balance on hold route is implemented -->
                                  <!-- <br><span class="badge badge-light-primary mt-sm-1" style="cursor: pointer" @click="showBalanceOnHold(account)">show ledger</span> -->
                                </td>
                                <td>
                                  <span class="font-weight-bolder text-dark">{{ modifyAmount(parseFloat(account.available_balance / 100).toFixed(8), 8) }}</span>
                                  <br><span class="badge badge-light-success">{{ currencyCode(account) }}</span>
                                  <!-- TODO: enable once the available balance flow is implemented -->
                                  <!-- <br><span class="badge badge-light-primary mt-sm-1" style="cursor: pointer" @click="showBalance(account)">show balance</span> -->
                                </td>
                                <td v-if="account.status == 1"><span class="badge badge-success badge-glow badge-sm">Active</span></td>
                                <td v-else-if="account.status == 2"><span class="badge badge-danger badge-glow badge-sm">Inactive</span></td>
                                <td v-else-if="account.status == 3"><span class="badge badge-info badge-glow badge-sm">Suspended</span></td>
                                <td v-else-if="account.status == 4"><span class="badge badge-primary badge-glow badge-sm">Closed</span></td>
                                <td v-else><span class="badge badge-dark badge-glow badge-sm">Pending</span></td>
                                <td>
                                  <span class="font-weight-bolder text-dark">{{ customFormatDateTime(account.created_at) }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['propFilters'],
  mounted() {
    let partnerDetails = this.$store.getters.getByKey("partnerDetails")

    if (!partnerDetails || !partnerDetails.row || partnerDetails.row.id != this.$route.params.id) {
      // nothing selected (e.g. direct URL hit), go back to the listing
      this.backTo()
      return
    }

    this.partner = partnerDetails.row
    this.accounts = Array.isArray(this.partner.accounts) ? this.partner.accounts : []
  },
  data() {
    return {
      partner: null,
      accounts: []
    }
  },
  methods: {
    currencyCode(account) {
      return account.currency && account.currency.code ? account.currency.code : '-'
    },
    showLedger(account) {
      // same ledger page as merchants; the query flag tells it to hide filters and export
      this.$router.push({
        name: 'account-ledger-merchant',
        params: { id: account.id, uuid: this.partner.id },
        query: { from: 'partner' }
      })
    },
    showBalanceOnHold(account) {
      // TODO: route redirection to the balance on hold ledger will be implemented later
      return account
    },
    showBalance(account) {
      // TODO: available balance modal / redirection will be implemented later
      return account
    },
    backTo() {
      let propFilters = this.propFilters
      this.$router.push({ name: 'partners', params: { propFilters } })
    }
  }
}
</script>
